import styled from 'styled-components';

export const MarketplaceWrapper = styled.div`

  height: 100%;
  color: #fff;
  background-color: #14181d;
  .sidebar-container {
    overflow: auto;
    margin: 0rem 1rem;
    padding-top: 10px;
    hr {
      margin: 1rem 0;
    }
    .filters-container {
      // padding: 1rem;
      // background-color: #1b2026;
      .dropdown-filter {
      }
    }
  }
  .nft-container {
    overflow: auto;
    background-color: #1b2026;
    .banner {
      h1 {
        font-size: xxx-large;
      }
      h3 {
        color: #bdc0c2;
      }
      margin: 1rem;
      text-align: center;
    }
    .nft-items {
      display: grid;
      justify-content: center;
      grid-template-columns: repeat(auto-fill, minmax(18rem, 270px));
      .nft-card {
        cursor: pointer;
        display: grid;
        align-items: end;
        border: 1px solid orange;
        border-radius: 10px;
        margin: 1rem;
        padding: 1.5rem;
        .nft-options {
          position: relative;
          display:grid;
          grid-template-columns: auto auto;
          justify-content: space-between; 
        }
        .img-container {
          display: grid;
          grid-template-columns: 1fr;
          justify-self: center;
          padding: .5rem 0rem;
          height: 150px;
          img {
            align-self: baseline;
            justify-self: center;
            max-height: 70%;
            max-width: 100%;
          }
        }
        .nft-info {
          h3 {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .nft-count {
            span {
              color: #bdc0c2;
            }
          }
          .nft-sales {
            display:grid;
            grid-template-columns: repeat(2,auto);
            justify-content: space-between;
            align-items: center;
            .nft-price {
              display: grid;
              grid-template-columns: repeat(2, auto);
              gap: .5rem;
              div {
                display: grid;
                span:first-child {
                  font-size: 16px;
                  line-height: 17px;
                
                  color: #ffbf36;
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }
  }
  
  @media all and (max-width: 575px) {
    grid-template-columns: 1fr;
    .sidebar-container {
      text-align: center;
    }
    .dropdown-filter .MuiAutocomplete-root {
      margin-left: 20px !important;
      margin-top: 15px;
    }
    .dropdown-filter .MuiFormControl-root {
      margin-top: 15px;
    }
  }
`;